import { Attachments } from './Attachments';
import { Provider } from './Provider';
export function DocumentAttachments(props) {
    return (<Provider {...props}>
      <Attachments />
    </Provider>);
}
